import {fetchRequest, urlEmbodeeServices, urlNtsServices} from "./index";

export const EmbodeeService = {

  /**
   * Retrieves the customization "Product Info" breakdown (section/question/answer) for every
   * product in the given JBA product group's Embodee uniform design, keyed by productCode.
   *
   * @param uid - JBA product group uid (e.g. "UD6729a84c906e9")
   */
  getProductSelections: (uid) => {
    const request = new Request(`${urlNtsServices}/embodee/product/${uid}.json`, {
      method: 'GET',
      headers: {'Accept': 'application/json'}
    });
    return fetchRequest(request, false);
  },

  getInspirationsByStyle: (styleNumber) => {
    let url = `${urlEmbodeeServices}/builder/ud/list/${styleNumber}/single`;
    const request = new Request(url, {
      method: 'GET',
      headers: {'Content-Type': 'application/xml', 'Accept': 'text/html,application/xhtml+xml,application/xml'}
    });
    return fetchRequest(request);
  }

};
